import React from 'react';
import ModalBase from 'react-modal';

const Modal = ({
  isOpen = false,
  onAfterOpen,
  closeModal,
  children,
  overlayStyle = {},
  reactModalContentClass
}) => {
  return (
    <div>
      <ModalBase
        isOpen={isOpen}
        onAfterOpen={onAfterOpen}
        onRequestClose={closeModal}
        style={{ overlay: overlayStyle}}
        appElement={document.getElementById('root')}
        className={reactModalContentClass ? reactModalContentClass : ''}
      >
        {children}
      </ModalBase>
    </div>
  );
};

export default Modal;